const prefix = process.env.VUE_APP_API_PREFIX
const commonParams = {
  startDate: '',
  endDate: '',
  channel: []
}
export default [
  {
    name:'getDomainOptions',
    path: `${prefix}/domain/list`,
    method: 'get',
    params: {
      page: 1,
      limit: 1000000,
      domain: '',
      https: '',
      ip: '',
      status: '',
      groupId:''
    },
    desc:'获取域名列表'
  },
  {
    name:'getPermanentDomainList',
    path: `${prefix}/waap/ms-config/domain/getPermanentDomainList`,
    method: 'post',
    params: {
      startTime: '',
      endTime: ''
    },
    desc:'获取waap域名列表'
  },
  {
    name:'getTrafficBandwidth',
    path: `${prefix}/traffic/bandwidth`,
    method: 'post',
    params: {
      ...commonParams,
      interval: ''  // 时间粒度， 可选值：5min、hour、day
    },
    desc:'查询流量和带宽'
  },
  {
    name:'getTotalRequest',
    path: `${prefix}/traffic/totalHits`,
    method: 'post',
    params: {
      ...commonParams,
      interval: ''  // 时间粒度， 可选值：5min、hour、day
    },
    desc:'查询域名对应总请求数'
  },
  {
    name:'getRequestTrend',
    path: `${prefix}/traffic/dyHit`,
    method: 'post',
    params: {
      ...commonParams,
    },
    desc:'查询请求数趋势图'
  },
  {
    name:'getStatusTrend',
    path: `${prefix}/traffic/statusTrend`,
    method: 'post',
    params: {
      ...commonParams,
    },
    desc:'查询状态码趋势'
  },
  {
    name:'getDomainRank',
    path: `${prefix}/traffic/bandwidthPeakRanking`,
    method: 'post',
    params: {
      ...commonParams,
      top: 5  // 排名前几
    },
    desc:'查询域名Top'
  },
  {
    name:'getAreaRank',
    path: `${prefix}/traffic/areaRanking`,
    method: 'post',
    params: {
      ...commonParams,
      top: 5  // 排名前几
    },
    desc:'查询地区Top'
  },
  {
    name:'getIpRank',
    path: `${prefix}/traffic/requestIPRanking`,
    method: 'post',
    params: {
      ...commonParams,
      top: 5  // 排名前几
    },
    desc:'查询客户端IpTop'
  },
  {
    name:'getUrlRank',
    path: `${prefix}/traffic/urlRanking`,
    method: 'post',
    params: {
      ...commonParams,
      top: 5  // 排名前几
    },
    desc:'查询urlTop'
  },
  {
    name:'getStatusRank',
    path: `${prefix}/traffic/statusRanking`,
    method: 'post',
    params: {
      ...commonParams,
      top: 5  // 排名前几
    },
    desc:'查询状态码Top'
  },

  {
    name:'getStatusRankDetail',
    path: `${prefix}/traffic/statusRankingDetail`,
    method: 'post',
    params: {
      ...commonParams,
      status: '' , // 状态码
      top: 100
    },
    desc:'查询错误状态码详情'
  },

]